import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'currencySymbol',
    standalone: true
})
export class CurrencySymbolPipe implements PipeTransform {

    transform(value: string | null | undefined, override?: string): string {
        const input = (override || value || '').trim().toLowerCase();

        switch (input) {
            case 'eur':
            case 'euro':
                return '€';
            case 'usd':
            case 'dollar':
                return '$';
            case 'gbp':
            case 'pound':
                return '£';
            case 'try':
            case 'tl':
            case 'lira':
                return '₺';
            case 'chf':
            case 'franc':
            case 'swiss franc':
                return 'CHF';
            default:
                return input.toUpperCase();
        }
    }
}
